import React, { useEffect, useState } from 'react';
export function StickyAlertBar() {
  const [isVisible, setIsVisible] = useState(true);
  // Optional: Hide on scroll down, show on scroll up logic could go here
  // For now, keeping it sticky as requested
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full bg-black text-gold-400 z-50 overflow-hidden py-2 shadow-lg border-b border-gold-600/30" data-id="element-340">
      <div className="whitespace-nowrap animate-marquee font-bold tracking-wider text-sm md:text-base flex items-center" data-id="element-341">
        <span className="mx-4" data-id="element-342">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-343">•</span>
        <span className="mx-4" data-id="element-344">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-345">•</span>
        <span className="mx-4" data-id="element-346">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-347">•</span>
        <span className="mx-4" data-id="element-348">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-349">•</span>
        <span className="mx-4" data-id="element-350">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-351">•</span>
        <span className="mx-4" data-id="element-352">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-353">•</span>
      </div>
    </div>;
}